import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { removeDimensionShadows, setUnitsShadowsTrue } from '../gltfLoaderHelpers/shadowHelper'

const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('/assets/draco/')
const gltfloader = new GLTFLoader()
gltfloader.setDRACOLoader(dracoLoader)

function load_room(model_path, done, progress,) {
    gltfloader.load(
        model_path,
        (gltf) => {

            gltf.scene.position.set(0.63 * (bbox(new THREE.Box3().setFromObject(gltf.scene)).max.x - bbox(new THREE.Box3().setFromObject(gltf.scene)).min.x),//X
                0.5,//Y
                1.2 * (bbox(new THREE.Box3().setFromObject(gltf.scene)).max.z - bbox(new THREE.Box3().setFromObject(gltf.scene)).min.z))//Z

            gltf.scene.rotation.set(0, 4.71, 0)

            setUnitsShadowsTrue(gltf.scene)

            let items = [];

            gltf.scene.children.forEach((child, i) => {
                if (i > 0 && (child.type == 'Object3D' || child.type == 'Mesh')) {
                    child.corner = {
                        x: bbox(new THREE.Box3().setFromObject(gltf.scene)).min.x,//X   
                        y: bbox(new THREE.Box3().setFromObject(gltf.scene)).max.y,//Y
                        z: bbox(new THREE.Box3().setFromObject(gltf.scene)).min.z//Z
                    };
                    items.push(child);
                }
            })

            items.sort((first, second) => {
                if (first.corner.y > second.corner.y) return 1;
                else if (first.corner.x > second.corner.x) return 1;
                else if (first.corner.z > second.corner.z) return 1;
                else return -1;
            })

            done({
                items: items,
                unit: gltf.scene,
            })
            items = null
            gltf.scene = null
            //console.log(items,unit)
        },
        (loading) => {
            progress(loading.loaded, loading.total, loading)
        },
        () => {
            console.log('The Scene Failed to Load!')
            done({
                items: [],
                unit: null
            })
        }
    )
}

function bbox(bbox) {
    return bbox
}

export {
    load_room,
}
